module.exports = __webpack_public_path__ + "pg-logo.png?ceae7443e41e1373a95af339fbf911e4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pg-logo.png
// module id = 116
// module chunks = 0